import React, { useEffect, useState } from 'react';
import BRTooltip from '../../assets/dsgov/js/components/tooltip';
import { parseProps, componentIdGenerator } from './@uteis';
import '../../assets/dsgov/css/components/tooltip.css';

const Tooltip = (_props) => {
  const props = parseProps(_props);
  const [componentId] = useState(
    `tooltip${componentIdGenerator()}`,
  );
  useEffect(() => {
    new BRTooltip('br-tooltip', window.document.querySelector(`.${componentId}`));
  }, []);

  const attr = {
    place: props.place,
    active: props.active,
    timer: props.timer,
    warning: props.warning,
    error: props.error,
  };

  let classes = `br-tooltip ${componentId}`;
  if (props.classes) { classes = `${classes} ${props.classes}`; }

  return (
    <>
      <div />
      <div className={classes} {...attr}>
        <span className="text">
          {props.children}
        </span>
      </div>
    </>
  );
};

export default Tooltip;
